import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9fe030da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "devhistory" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "one-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-year animate__fadeInDown wow" }, " 2021 ", -1))
const _hoisted_5 = { class: "line-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-circle animate__fadeInDown wow" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" })
], -1))
const _hoisted_7 = { class: "month-text animate__fadeInDown wow" }
const _hoisted_8 = { class: "line-text" }
const _hoisted_9 = { class: "one-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-wow-delay": "0.5s",
  class: "line-year animate__fadeInDown wow"
}, " 2022 ", -1))
const _hoisted_11 = { class: "line-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-wow-delay": "0.5s",
  class: "line-circle animate__fadeInDown wow"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" })
], -1))
const _hoisted_13 = {
  "data-wow-delay": "0.5s",
  class: "month-text animate__fadeInDown wow"
}
const _hoisted_14 = { class: "line-text" }
const _hoisted_15 = { class: "line-text" }
const _hoisted_16 = { class: "one-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-wow-delay": "1s",
  class: "line-year animate__fadeInDown wow"
}, " 2023 ", -1))
const _hoisted_18 = { class: "line-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-wow-delay": "1s",
  class: "line-circle animate__fadeInDown wow"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" })
], -1))
const _hoisted_20 = {
  "data-wow-delay": "1s",
  class: "month-text animate__fadeInDown wow"
}
const _hoisted_21 = { class: "line-text" }
const _hoisted_22 = { class: "line-text" }
const _hoisted_23 = { class: "line-text" }
const _hoisted_24 = { class: "line-text" }
const _hoisted_25 = { class: "line-text" }
const _hoisted_26 = { class: "one-item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-year animate__fadeInDown wow" }, " 2024 ", -1))
const _hoisted_28 = { class: "line-item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-circle animate__fadeInDown wow" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" })
], -1))
const _hoisted_30 = { class: "month-text animate__fadeInDown wow" }
const _hoisted_31 = { class: "line-text" }
const _hoisted_32 = { class: "one-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-year animate__fadeInDown wow" }, " 2025 ", -1))
const _hoisted_34 = { class: "line-item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-circle animate__fadeInDown wow" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" })
], -1))
const _hoisted_36 = { class: "month-text animate__fadeInDown wow" }
const _hoisted_37 = { class: "line-text" }
const _hoisted_38 = { class: "line-text" }
const _hoisted_39 = { class: "line-text" }
const _hoisted_40 = { class: "line-text" }
const _hoisted_41 = { class: "one-item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-year animate__fadeInDown wow" }, " 2026 ", -1))
const _hoisted_43 = { class: "line-item" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-circle animate__fadeInDown wow" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" })
], -1))
const _hoisted_45 = { class: "month-text animate__fadeInDown wow" }
const _hoisted_46 = { class: "line-text" }
const _hoisted_47 = { class: "line-text" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right animate__flipInX wow" }, null, -1))
const _hoisted_49 = {
  class: "title",
  id: "devhistory"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

import { onMounted, ref } from "vue"
import WOW from 'wowjs'

export default /*#__PURE__*/_defineComponent({
  __name: 'DevHistory',
  setup(__props) {

onMounted(async () => {
  new WOW.WOW({ live: false }).init()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('January')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('Incorporation')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('September')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('Egret Star')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('Outstanding Enterprise')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('top 500')), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('November')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('High-level Talents')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('March')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('Construction')), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('August')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('Testing Center')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('Singapore')), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('October')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('ChnPlan')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('Headquarters')), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Nov')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('High-tech Enterprise')), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Dec')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('HundrTalent')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('November')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('GetFujianB')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('March')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('Brand')), 1)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('June')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('FuJianComany')), 1)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('November')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('ISO13485')), 1)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Dec')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('ZhuanJingTeXin')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('TechSME')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('January')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('FutureIndustry')), 1)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('March')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('BioMaterialLab')), 1)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_48,
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('DevHistory')), 1),
      _hoisted_50,
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('subhistory')), 1)
    ])
  ]))
}
}

})